// 로그인·가입 경로는 앱 공용(shared/lib/auth-paths)이 만든다 — 게이트 모달·마이페이지·가입 완료
//   화면이 같은 문자열을 각자 조립하면 인코딩을 빠뜨린 곳이 하나쯤 생긴다. 게이트 쪽 이름은 유지한다.
export { loginPathWithNext, signupPathWithNext } from '@/shared/lib/auth-paths';

/** 로그인 복귀 후 자동 재개를 트리거하는 쿼리 파라미터 (D3 — 다운로드 의도 보존). */
export const DOWNLOAD_PARAM = 'download';

/** 로그인/가입을 마치고 돌아올 주소 — 어떤 자료를 받으려 했는지까지 들고 다닌다. */
export function gateNextPath(resumePath: string, assetId: string): string {
  return `${resumePath}?${DOWNLOAD_PARAM}=${encodeURIComponent(assetId)}`;
}
